import { useCallback } from "react";
import FBTrackingService from "@/services/fbTrackingService";

/**
 * Wraps a click handler with tracking
 * @param eventName - The tracking event name
 * @param eventData - Optional data to attach to the event
 * @returns A function that wraps the original handler with tracking
 *
 * @example
 * const handlePress = useTrackClick(
 *   TRACKING_EVENTS.HOTEL_REFUND_CLICKED,
 *   reservation
 * )(() => {
 *   // your click logic here
 * });
 */
export function useTrackClick(eventName: string, eventData?: any) {
  return useCallback(
    (originalHandler?: () => void | Promise<void>) => {
      return async () => {
        FBTrackingService.trackEvent(eventName, { eventData });
        await originalHandler?.();
      };
    },
    [eventName, eventData]
  );
}
